export default function uniqueControlTypeNameDirective(
  $q,
  controlDataService
) {
  // console.log('app.components.advisory.enterpriseModeling.departmentUniqueNameValidator created');
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attributes, ngModel) => {
      const customerControlTypeId = attributes.customerControlTypeId || 0;
      ngModel.$asyncValidators.controlTypeUniqueName = (modelValue) => {
        const defer = $q.defer();
        controlDataService.checkControlTypeNameExists(customerControlTypeId, modelValue).then((data) => {
          if (data && data.data.result === false) {
            defer.resolve();
          } else {
            defer.reject();
          }
        }).catch(defer.reject);
        return defer.promise;
      };
    },
  };
}

export const name = 'controlTypeUniqueName';

uniqueControlTypeNameDirective.$inject = [
  '$q',
  'controlDataService',
];
